import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getSession, logout } from '../partnerAuth';
import { COLOR, FONT } from '../theme';

const TABS = [
  { path: '/partner', label: 'Today' },
  { path: '/partner/wallet', label: 'Earnings' },
];

export default function PartnerShell({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const session = getSession();

  const handleLogout = () => {
    logout();
    navigate('/partner/login');
  };

  return (
    <div style={S.page}>
      <header style={S.nav}>
        <div style={S.navIn}>
          <div style={S.brand}>
            <div>
              <div style={S.brandName}>Red<span style={S.brandSpeed}>Speed</span> GapGo</div>
              <div style={S.brandSub}>Partner</div>
            </div>
          </div>
          <div style={S.navRight}>
            {session && <span style={S.email}>{session.email}</span>}
            <button style={S.logout} onClick={handleLogout}>Sign out</button>
          </div>
        </div>
        <div style={S.tabs}>
          {TABS.map((t) => {
            const active = location.pathname === t.path;
            return (
              <button
                key={t.path}
                onClick={() => navigate(t.path)}
                style={{
                  ...S.tab,
                  color: active ? COLOR.text : COLOR.textFaint,
                  borderBottom: active ? `2px solid ${COLOR.accent}` : '2px solid transparent',
                }}
              >
                {t.label}
              </button>
            );
          })}
        </div>
      </header>
      <main style={S.main}>{children}</main>
    </div>
  );
}

const S = {
  page: { minHeight: '100vh', background: COLOR.bg, color: COLOR.text, fontFamily: FONT },
  nav: { borderBottom: `1px solid ${COLOR.hairline}`, position: 'sticky', top: 0, background: COLOR.bg, zIndex: 10 },
  navIn: {
    maxWidth: '760px', margin: '0 auto', padding: '16px 20px 12px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px',
  },
  brand: { display: 'flex', alignItems: 'center' },
  brandName: { fontSize: '16px', fontWeight: '700', letterSpacing: '-0.3px', lineHeight: 1.1, color: COLOR.text, whiteSpace: 'nowrap' },
  // Matches redspeed.com.au's own lockup: "Red" in text colour, "Speed" in brand red.
  brandSpeed: { color: COLOR.accent },
  brandSub: { fontSize: '10px', letterSpacing: '2px', color: COLOR.accent, fontWeight: '700' },
  navRight: { display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 },
  email: {
    fontSize: '12.5px', color: COLOR.textFaint, overflow: 'hidden',
    textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '180px',
  },
  logout: {
    background: 'transparent', border: `1px solid ${COLOR.glassBorder}`, borderRadius: '20px',
    padding: '7px 14px', color: COLOR.textMuted, fontSize: '12.5px', fontWeight: '600',
    cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0,
  },
  tabs: { maxWidth: '760px', margin: '0 auto', padding: '0 20px', display: 'flex', gap: '4px' },
  tab: {
    background: 'transparent', border: 'none', padding: '10px 14px', fontSize: '14px',
    fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit', transition: 'color 0.2s',
  },
  main: { maxWidth: '760px', margin: '0 auto', padding: '24px 20px 60px' },
};
